var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkOpen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.293 19.663l-1.727.245.523 3.696 1.73-.245-.526-3.696zm2.649-4.132l-.246 1.729 3.698.524.246-1.726-3.698-.527zm.596 6.189l1.232-1.233-2.645-2.642-1.231 1.234 2.644 2.641zm.459-20.916c2.87 1.659 3.854 5.328 2.198 8.196l-2.752 4.767-1.737-1 2.754-4.766c1.104-1.911.447-4.362-1.466-5.464-1.911-1.103-4.362-.447-5.465 1.464l-2.752 4.765-1.735-1 2.752-4.765c1.658-2.87 5.33-3.853 8.203-2.197zm-7.276 19.671l-4.715 2.72c-2.869 1.658-6.543.674-8.203-2.196-1.653-2.87-.673-6.541 2.198-8.196l4.715-2.721 1 1.732-4.713 2.722c-1.911 1.104-2.567 3.554-1.466 5.463 1.107 1.911 3.556 2.567 5.47 1.465l4.712-2.72 1.002 1.731z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkOpen);
export default __webpack_public_path__ + "static/media/LinkOpen.f7b93a94.svg";
export { ForwardRef as ReactComponent };